import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import Image from "next/image";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Stack } from "@mui/material";
import RoundButton from "../../../components/common/button/RoundButton";
import AgapeIcon from "../../../components/common/icons/AgapeIcon";

import options from "../../../public/assets/images/options.png";
import install_android from "../../../public/assets/images/install_android.png";
import logo from "../../../public/assets/images/agapelogonew.png";
import CloseIcon from "@mui/icons-material/Close";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import addIos from "../../../public/assets/images/add_box.svg";
import bazaar from "../../../public/assets/images/bazaar.svg";
import myketmarket from "../../../public/assets/images/myketmarket.svg";
import directDownloadBadge from "../../../public/assets/images/direct-download-badge.svg";
import Link from "next/link";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#009693",
    fontSize: 16,
    marginTop: 20,
    fontWeight: "bold",
  },
  t1: {
    fontSize: 14,
  },
  t2: {
    color: "#FF5666",
  },
  fixedMenu: {
    position: "fixed",
    left: "0",
    right: "0",
    bottom: "20px",
    zIndex: "9999",
    padding: "8px 0px",
    backgroundColor: "#fff",
    height: "100px",
  },
  btn: {
    backgroundColor: "transparent",
    color: "#009693",
    width: "100%",
    marginTop: "20px",
    marginBottom: "30px",
  },
  btn2: {
    width: "60%",
    marginTop: "30px",
    marginBottom: "30px",
  },
  installbtn: {
    width: "30%",
  },
}));

const DialogInstallPWA = () => {
  const [showInstall, setShowInstall] = useState(false);
  const [showFixedMenu, setShowFixedMenu] = useState(false);
  const [showInsallApp, setShowInstallApp] = useState(true);
  const router = useRouter();
  const classes = useStyles();

  useEffect(() => {
    const hasModalBeenShown = sessionStorage.getItem("modalShown");
    if (!hasModalBeenShown && (isMobile || isAndroid || isIOS)) {
      setShowFixedMenu(true);
    }
  }, [router]);

  const handleCloseDialog = () => {
    setShowInstall(false);
    sessionStorage.setItem("modalShown", true);
  };

  const handleInstallClick = () => {
    setShowInstall(true);
  };
  const handleCloseBanellInstall = () => {
    setShowInstallApp(false);
    sessionStorage.setItem("modalShown", true);
  };
  const deviceInstructions = () => {
    if (isIOS && isMobile) {
      return (
        <Grid
          container
          style={{ maxWidth: "100%", lineHeight: "40px", height: "100%" }}
          spacing={1}
        >
          <Grid item xs={12}>
            <Typography className={classes.t1} style={{ fontWeight: "bold" }}>
              {" "}
              راهنمای نصب اپلیکیشن آگاپه نسخه ios
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" className={classes.t1}>
              1.دکمه
              <span className={classes.t2}>
                {" "}
                Share <span style={{ fontSize: "20px" }}>(</span>
                <IosShareOutlinedIcon
                  style={{ width: "24px", height: "24px" }}
                />
                <span style={{ fontSize: "20px" }}>)</span>
              </span>{" "}
              در نوار پایین را انتخاب کنید.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.t1}>
              2.گزینه
              <span className={classes.t2}>
                {" "}
                Add to Home Screen <span style={{ fontSize: "20px" }}>(</span>
                <AddBoxOutlinedIcon
                  style={{ width: "24px", height: "24px", marginRight: "5px" }}
                />
                <span style={{ fontSize: "20px" }}> )</span>
              </span>{" "}
              را انتخاب کنید
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.t1}>
              3.در قسمت بالا روی <span className={classes.t2}> Add </span> کلید
              کنید
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <RoundButton className={classes.btn2} onClick={handleCloseDialog}>
                متوجه شدم
              </RoundButton>
            </div>
          </Grid>
        </Grid>
      );
    } else if (isAndroid && isMobile) {
      return (
        <Grid
          container
          style={{
            maxWidth: "100%",
            lineHeight: "40px",
            height: "100%",
            padding: "25px",
          }}
          spacing={1}
        >
          <Grid item xs={12}>
            <Typography
              style={{
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "bold",
                marginBottom: "15px",
              }}
            >
              نصب اپلیکیشن آگاپه
            </Typography>
          </Grid>
          <Link href="https://cafebazaar.ir/app/com.agapengo.app.twa">
            <Grid item xs={12}>
              <Image
                src={bazaar}
                alt="bazaar"
                // style={{ width: "100%" }}
                placeholder="blur"
                blurDataURL={bazaar}
                layout="responsive"
              />
            </Grid>
          </Link>
          <Link href="https://myket.ir/app/com.agapengo.app.twa">
            <Grid item xs={12}>
              <Image
                src={myketmarket}
                alt="myketmarket"
                style={{ width: "100%" }}
                placeholder="blur"
                blurDataURL={myketmarket}
                layout="responsive"
              />
            </Grid>
          </Link>
          <Link href="https://minio.stage.agapengo.com/agape/api/media/agapengo.apk">
            <Grid item xs={12}>
              <Image
                src={directDownloadBadge}
                alt="directDownloadBadge"
                style={{ width: "100%" }}
                placeholder="blur"
                blurDataURL={directDownloadBadge}
                layout="responsive"
              />
            </Grid>
          </Link>

          <Grid item xs={12}>
            <RoundButton className={classes.btn} onClick={handleCloseDialog}>
              فعلا نه
            </RoundButton>
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Dialog
        open={showInstall}
        onClose={handleCloseDialog}
        aria-labelledby="install-pwa-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              width: "100%",
              padding: 10,
              margin: 0,
              height: "530px",
            }}
          >
            <div
              style={{
                minWidth: "100%",
                height: isAndroid ? "30%" : "40%",
              }}
            >
              <Image
                placeholder="blur"
                src={logo}
                alt="logo"
                // style={{ width: "100%" }}
                layout="responsive"
                width={170}
                height={170}
              />
            </div>
            <div
              style={{
                height: "50%",
                marginTop: isAndroid ? "20px" : "30px",
              }}
            >
              {deviceInstructions()}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {showFixedMenu && showInsallApp && (
        <div
          className={classes.fixedMenu}
          style={{ display: showInsallApp ? "block" : "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent: "space-between",
                width: "50%",
              }}
            >
              <IconButton onClick={handleCloseBanellInstall}>
                <CloseIcon style={{ color: "#b6b3b3" }} />
              </IconButton>
              <Image
                placeholder="blur"
                src={logo}
                alt="logo"
                width={40}
                height={40}
              />
              <Typography style={{ fontWeight: "bold" }}>
                اپلیکیشن آگاپه
              </Typography>
            </div>
            <RoundButton
              onClick={handleInstallClick}
              className={classes.installbtn}
            >
              نصب
            </RoundButton>
          </div>
        </div>
      )}
    </>
  );
};

export default DialogInstallPWA;
